import "./WhatWeDone.scss"
import Slider from "react-slick";
import React, {useEffect, useRef} from "react";

const LeftArrow = "https://cdn.deepsense.space/Ripple/World/left-arrow.png";
const RightArrow = "https://cdn.deepsense.space/Ripple/World/right-arrow.png";

const Video1 = "https://cdn.deepsense.space/Ripple/World/video-1.mp4";
const Video2 = "https://cdn.deepsense.space/Ripple/World/video-2.mp4";
const Video3 = "https://cdn.deepsense.space/Ripple/World/video-3.mp4";
const Video4 = "https://cdn.deepsense.space/Ripple/World/video-4.mp4";


const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive:[
        {
            breakpoint: 768,
            settings: {
                infinite: false,
                slidesToShow: 1.25,
                slidesToScroll:1,
                arrows:false,
                // speed: 1000
            }
        },
    ],
    // adaptiveHeight:true,
    lazyLoad: true,
};

export const WhatWeDone = (props) => {
    const videoData = [
        {
            video:Video1,
            title:"Let users experience 3D innovation win all your products"
        },
        {
            video:Video2,
            title:"Let customers view your products with an interactive product showcase from their own homes and increase user interaction."
        },
        {
            video:Video3,
            title:"While giving them with product information, let your users see a product come to life"
        },
        {
            video:Video4,
            title:"With the help of our augmented reality 3D business cards enhanced with holograms, photos, movies, and other multimedia"
        }
    ];
     return(
        <div className={"what-we-done-component"}>
            <div className={"content-section"}>
                <p className={"title"}>Explore RippleAR</p>
                <p className={"description"}>
                    We have created the tool developers, agencies and brands required to make immersive web content everyone can experience.  ​
                </p>
            </div>
            <div className={"slider-container"}>
                <Slider {...settings}>
                    {
                        videoData.map((item,index)=>{
                            return(
                                <div key={index}>
                                    <VideoCardSection data={item} />
                                </div>
                            )
                        })
                    }
                </Slider>
            </div>
        </div>
    );
}

const VideoCardSection = (props) => {
    const videoRef = useRef();
    const circlePlayButtonRef = useRef();
    const {data} = props;
    useEffect(()=>{
        circlePlayButtonRef.current.addEventListener("click", togglePlay);
        videoRef.current.addEventListener("playing", function () {
            circlePlayButtonRef.current.style.opacity = 0;
        });
        videoRef.current.addEventListener("pause", function () {
            circlePlayButtonRef.current.style.opacity = 1;
        });

    },[])

    const togglePlay = () => {
        if (videoRef.current.paused || videoRef.current.ended) {
            videoRef.current.play();
        } else {
            videoRef.current.pause();
        }
    }
    return(
        <div className={"video-card-component"}>
            <div className={"video-section"}>
                <div className="video-wrapper">
                    <div className="video-container" id="video-container">
                        <video width={"100%"} height={"100%"}  playsInline={true} id="video" ref={videoRef} preload="metadata">
                            <source src={data.video} type="video/mp4"/>
                        </video>
                        <div className="play-button-wrapper">
                            <div title="Play video" className="play-gif" id="circle-play-b" ref={circlePlayButtonRef}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
                                    <path d="M40 0a40 40 0 1040 40A40 40 0 0040 0zM26 61.56V18.44L64 40z"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <p className={"title"}>{data.title}</p>
            {/*<MDBBtn className={"try-now-btn d-flex justify-content-center align-items-center"}>Try Now</MDBBtn>*/}

        </div>
    )
}

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{ ...style, display: "block" }}
            onClick={onClick}
        >
            <img src={RightArrow} alt={"right-arrow"} width={"21px"}/>
        </div>
    );
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{ ...style, display: "block" }}
            onClick={onClick}
        >
            <img src={LeftArrow} alt={"right-arrow"} width={"21px"}/>
        </div>
    );
}
